"use client";

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { Form, Modal } from "react-bootstrap";
import "./Contact_Grid.css";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";

const Contact_Grid = () => {
  const contactInfo = [
    {
      title: "Our Office",
      icon: faMapMarkerAlt,
      address:
        "Ground Floor, Near Amethi Mandir, Khoraram Road, Deoria - 274001, Uttar Pradesh",
    },
    {
      title: "Call Us",
      icon: faPhone,
      numbers: [
        {
          type: "Main",
          phone: "+91 9762331812",
          note: "Available 24/7 for urgent queries",
        },
        {
          type: "Whatsapp",
          phone: "+91 96518 00482", // Replace with the second number
          note: "Available for general queries",
        },
      ],
    },
    {
      title: "Email Us",
      icon: faEnvelope,
      emails: [
        {
          type: "Email 1",
          email: "kumar@lkaumodaki.com",
        
        },
        {
          type: "Email 2",
          email: "bdm@lkaumodaki.com", // Replace with your second email
         
        },
      ],
    },
  ];

  return (
    <section className="contact_grid_section">
      <Container>
        <div className="contact_grid_content">
          <CommonHeading title="Contact Us" />

          <Row className="g-3">
            {contactInfo.map((item, index) => (
              <Col lg={4} md={6} sm={12} key={index}>
                <div className="contact_grid_item">
                  {/* Icon */}
                  <div className="contact_grid_icon">
                    <FontAwesomeIcon icon={item.icon} />
                  </div>

                  {/* Details */}
                  <div className="contact_grid_details">
                    <h3>{item.title}</h3>

                    {/* Address */}
                    {item.address && (
                      <p className="contact_grid_address">{item.address}</p>
                    )}

                    {/* Phone Numbers */}
                    {item.numbers && (
                      <div className="contact_grid_numbers">
                        {item.numbers.map((number, numberIndex) => (
                          <div
                            className="contact_grid_number"
                            key={numberIndex}
                          >
                            <span className="contact_grid_type">
                              {number.type}
                            </span>

                            <a href={`tel:${number.phone.replace(/\s+/g, "")}`}>
                              {number.phone}
                            </a>

                            {number.note && <small>{number.note}</small>}
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Email */}
                    {item.emails && (
                      <div className="contact_grid_email">
                        {item.emails.map((emailItem, emailIndex) => (
                          <div className="contact_grid_number" key={emailIndex}>
                            <span className="contact_grid_type">
                              {emailItem.type}
                            </span>

                            <a href={`mailto:${emailItem.email}`}>
                              {emailItem.email}
                            </a>

                            {emailItem.note && <small>{emailItem.note}</small>}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default Contact_Grid;
